export const rotate_ccw = () => (
  <path
    d="M1 4v6m0 0h6m-6 0l4.64-4.36A9 9 0 113.51 15"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
